import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button } from 'semantic-ui-react'
import { connectForm, ModalForm, Group, Form, Field, Submit, InfoGroup, Info } from '~/form'
import { createArticle } from '../actions'
import moment from 'moment'
import ArticleForm, { ArticleFormValidations } from './form'
import { fetchTaskTypes } from '~/taskType/actions'

class ArticleCreate extends Component {
  static formSubmit(dispatch, formId, values, changed, { onCreate }) {
    dispatch(createArticle(formId, values.toJS(), onCreate))
  }

  static formValidation = ArticleFormValidations

  componentDidMount = () => {
    let { formSetMeta, onCreate } = this.props

    if (onCreate) formSetMeta({ onCreate })
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose } = this.props

    let actions = (
      <Button
        size="tiny"
        color="green"
        content="Luo artikkeli"
        onClick={e => e.preventDefault() & formSubmit()}
        icon="save"
      />
    )

    return (
      <ModalForm id="article-form" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        <ArticleForm {...this.props} key="article-create" title="Luo uusi artikkeli" />
      </ModalForm>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connectForm('article-create', ArticleCreate, mapStateToProps, mapDispatchToProps)
